export function capitalizeWords(value: string) {
  return value.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
}
